<template>
    <div
        class="dictionary-menu fixed right-0 top-[71px] h-screen border-l z-10 flex flex-col items-center bg-base-100 px-1 py-2 gap-1 text-xs font-semibold lg:sticky lg:top-0 lg:flex-row lg:text-sm lg:py-4 lg:mb-6 lg:justify-between lg:h-auto lg:border-l-0 lg:border-b-2 lg:px-4"
    >
        <MiscLink
            class="link no-underline px-2"
            :to="localePath({ name: 'lexicon' })"
        >
            <MiscIcon
                name="menu"
                class="block lg:hidden"
            />
            <span class="hidden lg:block">
                {{ $t('lexicon.title') }}
            </span>
        </MiscLink>
        <MiscLink
            v-for="letter in groupedLetters"
            :key="letter"
            :to="localePath({ name: 'lexicon-char', params: { char: letter.toLocaleLowerCase() } })"
            class="px-2"
        >
            {{ letter }}
        </MiscLink>
    </div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
const { groupedLetters } = useDictionary()
</script>
